import { createServiceHTTPClientProvider, createBoundServiceMutationHookCreator } from "@airhelp/service-utils";
import { b as accessMagicLink, d as beginPasswordReset, g as createNewPassword, j as createUser, m as login, n as logout } from "./logout-yCeX-sS8.js";
const [AuthHTTPClientProvider, useAuthHTTPClient] = createServiceHTTPClientProvider({
  name: "Auth"
});
const createAuthMutationHook = createBoundServiceMutationHookCreator({
  useClient: useAuthHTTPClient
});
const useAccessMagicLink = createAuthMutationHook({
  mutationFn: accessMagicLink
});
const useBeginPasswordReset = createAuthMutationHook({
  mutationFn: beginPasswordReset
});
const useCreateNewPassword = createAuthMutationHook({
  mutationFn: createNewPassword
});
const useCreateUser = createAuthMutationHook({
  mutationFn: createUser
});
const useLogin = createAuthMutationHook({
  mutationFn: login
});
const useLogout = createAuthMutationHook({
  mutationFn: logout
});
export {
  AuthHTTPClientProvider,
  useAccessMagicLink,
  useAuthHTTPClient,
  useBeginPasswordReset,
  useCreateNewPassword,
  useCreateUser,
  useLogin,
  useLogout
};
//# sourceMappingURL=react.js.map
